import { render } from "./CollapsibleQuoteBreak.vue?vue&type=template&id=283dd4e4&scoped=true"
import script from "./CollapsibleQuoteBreak.vue?vue&type=script&lang=js"
export * from "./CollapsibleQuoteBreak.vue?vue&type=script&lang=js"

import "./CollapsibleQuoteBreak.vue?vue&type=style&index=0&id=283dd4e4&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283dd4e4"]])

export default __exports__